import {AppRole, roleHomePath} from '../../entities/auth/model';

export function resolveRouteRedirect(role: AppRole, allowedRoles: AppRole[] | undefined): string | null {
  if (!allowedRoles || allowedRoles.length === 0) {
    return null;
  }
  if (!allowedRoles.includes(role)) {
    return roleHomePath(role);
  }
  return null;
}
